import styled from 'styled-components';
import { Container } from '@material-ui/core';
import { Field } from 'formik';

interface CampaignTypeProps {
  active: boolean;
}

interface PreviousButtonProps {
  first?: boolean;
}

interface NavigationWrapperProps {
  activeStep: number;
}

export const CampaignType = styled.div<CampaignTypeProps>`
  padding: 20px 24px;
  margin: 6px 0;
  background-color: ${({ theme }) => theme.colors.paleBlue};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  border: ${({ active }) => active ? '2px solid #2A71D4' : '2px solid transparent'};
  cursor: pointer;
  > img {
    height: 62px;
  }
  .MuiFormControlLabel-label {
    color: ${({ theme }) => theme.colors.blue};
    font-weight: bold;
    font-size: 14px;
    opacity: .87;
    margin-left: ${({ theme }) => theme.spacing * 4}px;
  }
  @media screen and (max-width: 690px) {
    flex-direction: column;
    align-items: flex-start;
    > img {
      align-self: flex-end;
    }
  }
`;

export const StyledContainer = styled(Container)`
  padding-top: 60px;
  @media screen and (max-width: 690px) {
    padding: 0;
  }
`;

export const NavigationWrapper = styled.div<NavigationWrapperProps>`
  display: flex;
  justify-content: space-between;
  margin: 36px 0 0;
  @media screen and (max-width: 690px) {
    ${props => props.activeStep === 4 && `
      display: grid;
      grid-template-areas:
        'back draft'
        'send send';
      grid-row-gap: 16px;
    `}
  }
`;

export const ButtonNext = styled.button`
  min-width: 220px;
  height: 44px;
  color: ${({ theme }) => theme.colors.white};
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  outline: none;
  border: none;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  box-sizing: border-box;
  padding: 0 ${({ theme }) => theme.spacing * 12}px;
  grid-area: send;
  ${props => props.disabled && 'opacity: .38'};
`;

export const ButtonPrevious = styled.button<PreviousButtonProps>`
  border: none;
  outline: none;
  background-color: unset;
  color: ${({ first }) => first ? '#333333' : '#448AFF'};
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  height: 44px;
  line-height: 44px;
  display: flex;
  align-items: center;
  padding: 0;
  cursor: pointer;
  grid-area: back;
  > svg {
    width: 20px;
    opacity: .54;
    margin-right: ${({ theme }) => theme.spacing * 3}px;
  }
`;

export const ButtonDraft = styled(ButtonPrevious)`
  grid-area: draft;
  justify-self: end;
`;

export const BannerWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing * 6}px 0;
  padding: ${({ theme }) => theme.spacing * 3}px ${({ theme }) => theme.spacing * 10}px;
  background-color: ${({ theme }) => theme.colors.paleBlue};
  border-radius: 6px;
  font-size: 14px;
  line-height: 21px;
  color: #032A55;
  text-align: center;
  > a {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: bold;
  }
  @media screen and (max-width: 690px) {
    padding: ${({ theme }) => theme.spacing * 3}px ${({ theme }) => theme.spacing * 5}px;
  }
`;

export const Label = styled.p`
  margin: 0 0 ${({ theme }) => theme.spacing * 2}px;
  font-size: 12px;
  font-weight: bold;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
`;

export const StyledField = styled(Field)`
  && {
    margin: 0 0 ${({ theme }) => theme.spacing * 6}px;
  }
`;

export const ErrorText = styled.p`
  font-size: 12px;
  color: #f44336;
  margin: ${({ theme }) => theme.spacing}px 0 0;
`;
